import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  private subject = new BehaviorSubject<string>(null);
  locale$: Observable<string> = this.subject.asObservable();

  setLocale(lang: string): void {
    this.subject.next(lang);
  }
}
